package com.schoolconnect.app.feature.eventsnews

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.animation.core.*
import androidx.compose.runtime.*
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.*
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.list.*
import com.schoolconnect.app.feature.common.*
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.*
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.datasource.network.response.EventResponse
import com.schoolconnect.app.repository.files.FileUploadRepository
import com.schoolconnect.app.util.decodeImageBitmap
import com.schoolconnect.app.util.resizeImage
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogLabeledTextField
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerMode
import io.github.vinceglb.filekit.core.PickerType
import io.github.vinceglb.filekit.core.PlatformFile
import kotlinx.coroutines.launch
import kotlin.time.Clock

@Composable
fun EventsNewsScreen(
    state: EventsNewsUiState,
    onEvent: (EventsNewsUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsMenu by remember { mutableStateOf(false) }
    var addVisible by remember { mutableStateOf(false) }
    var editing by remember { mutableStateOf<EventRowUi?>(null) }
    var viewing by remember { mutableStateOf<EventRowUi?>(null) }
    var deleteTarget by remember { mutableStateOf<EventRowUi?>(null) }
    var customRangeVisible by remember { mutableStateOf(false) }
    val pageRows = state.rows
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)

    AdminListPageScaffold(
        title = "Events & News",
        subtitle = "Create and manage events and share news with parents.",
        backgroundColor = AppBackground, titleColor = AppPageHeader, subtitleColor = AppPageSubtitle,
        headerActions = { ShellTopRightActions(shellRoleLabel(shellRoleCode), shellRoleSubtitle(shellRoleCode), shellAvatarInitials(shellRoleLabel(shellRoleCode)), profileExpanded, { profileExpanded = it }, onChangeRole, onLogout) },
        summaryCards = { if (state.isStatisticsLoading) EventSummaryCardsShimmer() else {
            EventMetric("Total Events", state.totalEvents.toString(), "Across all events", Res.drawable.calendar, AppPrimary, AppPrimarySoft)
            EventMetric("Draft Events", state.draftEvents.toString(), "Not yet published", Res.drawable.edit, Color(0xFFFF7A00), Color(0xFFFFF0E3))
            EventMetric("Published Events", state.publishedEvents.toString(), "Currently published", Res.drawable.megaphone, AppSuccess, AppSuccessSoft)
            EventMetric("Expired Events", state.expiredEvents.toString(), "Past expiry date", Res.drawable.ban, AppDanger, AppDangerSoft)
        } },
        toolbar = { EventsFilterPanel(state, onEvent, onCustomRange = { customRangeVisible = true }) },
        table = { modifier ->
            AdminListTableCard(modifier = modifier, minContentWidth = 1060.dp,
                header = { EventHeader(state, onEvent) },
                body = {
                    when {
                        state.isLoading -> AdminListTableShimmer(columns = listOf(AdminListHeaderColumn("Event ID", .9f), AdminListHeaderColumn("Title", 1.6f), AdminListHeaderColumn("Type", 1.1f), AdminListHeaderColumn("Published On", 1f), AdminListHeaderColumn("Expiry Date", 1f), AdminListHeaderColumn("Status", .8f), AdminListHeaderColumn("Actions", .95f)), rowCount = state.pageSize)
                        state.errorMessage.isNotBlank() -> Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { AppDialogErrorMessage(state.errorMessage) }
                        pageRows.isEmpty() -> Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { Text("No events found", color = AppNavy, fontWeight = FontWeight.Bold) }
                        else -> AdminListTableBody(items = pageRows, key = { it.id }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                            EventRow(row, onView = { viewing = row; onEvent(EventsNewsUiEvent.ViewEvent(row.backendId)) }, onEdit = { editing = row; onEvent(EventsNewsUiEvent.ViewEvent(row.backendId)) }, onDelete = { deleteTarget = row })
                            HorizontalDivider(color = AppBorder)
                        }
                    }
                },
                footer = { AdminListFooter(pageText = pageFooterText(window, "events"), pageIndex = window.pageIndex, pageCount = window.pageCount, onPageChanged = { onEvent(EventsNewsUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsMenu, onRowsPerPageToggle = { rowsMenu = !rowsMenu }, onRowsPerPageDismiss = { rowsMenu = false }, onPageSizeChanged = { onEvent(EventsNewsUiEvent.PageSizeChanged(it)) }) }
            )
        },
        bottomAction = { Spacer(Modifier.weight(1f)); AdminListPrimaryActionButton(label = "Add Event", icon = painterResource(Res.drawable.plus), onClick = { addVisible = true }, modifier = Modifier.padding(top = 4.dp)) }
    )
    LaunchedEffect(state.saveGeneration) {
        if (state.saveGeneration > 0) {
            addVisible = false
            editing = null
        }
    }
    CustomEventDateRangeDialog(
        visible = customRangeVisible,
        initialFrom = state.filters.publishedDateFrom,
        initialTo = state.filters.publishedDateTo,
        onDismiss = { customRangeVisible = false },
        onApply = { from, to ->
            customRangeVisible = false
            onEvent(EventsNewsUiEvent.FiltersChanged(state.filters.copy(publishedDate = "Custom Range", publishedDateFrom = from, publishedDateTo = to)))
        }
    )
    if (addVisible) AddEventDialog(
        audienceOptions = state.audienceOptions,
        classTargetOptions = state.classTargetOptions,
        isSaving = state.isSaving,
        errorMessage = state.saveErrorMessage,
        onDismiss = { addVisible = false },
        onSubmit = { draft -> onEvent(EventsNewsUiEvent.CreateSubmitted(draft)) }
    )
    if (editing != null) AddEventDialog(
        initial = editing,
        audienceOptions = state.audienceOptions,
        classTargetOptions = state.classTargetOptions,
        isSaving = state.isSaving,
        isLoadingDetails = state.isViewingEvent,
        errorMessage = state.saveErrorMessage.ifBlank { state.viewEventError },
        onDismiss = { editing = null },
        onSubmit = { draft -> onEvent(EventsNewsUiEvent.UpdateSubmitted(draft)) }
    )
    val detail = state.viewingEvent
    val detailMedia = state.eventAttachments.filter { it.mimeType.startsWith("image/", true) || it.mimeType.startsWith("video/", true) }.map {
        EventAttachmentUi(null, it.name, it.sizeLabel, it.mimeType.startsWith("video/", true), it.previewBytes, it.url, it.fileId)
    }
    val detailDocuments = state.eventAttachments.filterNot { it.mimeType.startsWith("image/", true) || it.mimeType.startsWith("video/", true) }.map {
        EventDocumentAttachmentUi(null, it.name, it.mimeType.substringAfterLast('/', "FILE").uppercase(), it.sizeLabel, it.fileId, it.url)
    }
    EventPreviewDialog(
        event = viewing?.let { detail?.toEventViewRow(it) ?: it },
        media = if (detail != null) detailMedia else emptyList(),
        documents = if (detail != null) detailDocuments else emptyList(),
        isLoading = state.isViewingEvent,
        errorMessage = state.viewEventError,
        onDismiss = { viewing = null }
    )
    deleteTarget?.let { target ->
        AppConfirmationDialog(
            onDismiss = { deleteTarget = null },
            title = "Delete Event?",
            subtitle = "This event will be removed from active event records.",
            bodyText = "Delete ${target.title}?",
            confirmLabel = "Delete",
            tone = AppConfirmationDialogTone.Danger,
            onConfirm = { deleteTarget = null; onEvent(EventsNewsUiEvent.DeleteEvent(target.backendId)) }
        )
    }
    LaunchedEffect(state.viewingEvent, state.eventAttachments, editing?.backendId) {
        val current = editing ?: return@LaunchedEffect
        val response = state.viewingEvent ?: return@LaunchedEffect
        if (response.id == current.backendId && state.eventAttachments.isNotEmpty()) {
            editing = response.toEventViewRow(current, state.eventAttachments)
        }
    }
}

private fun eventMatchesStatus(displayStatus: String, filter: String): Boolean =
    filter.isBlank() || displayStatus.equals(filter.trim(), ignoreCase = true)

private fun eventMatchesPublishedDate(displayDate: String, filter: String): Boolean {
    if (filter.isBlank() || filter.equals("All", ignoreCase = true)) return true
    val date = displayDate.toEventDate() ?: return false
    val parts = Clock.System.now().toString().take(10).split('-').mapNotNull(String::toIntOrNull)
    if (parts.size != 3) return false
    val today = EventDate(parts[0], parts[1], parts[2])
    return when (filter.trim().lowercase()) {
        "today" -> date == today
        "last 7 days" -> date.serial() in (today.serial() - 6)..today.serial()
        "this month" -> date.year == today.year && date.month == today.month
        else -> true
    }
}

private data class EventDate(val year: Int, val month: Int, val day: Int)
private fun EventDate.serial(): Int {
    val daysBeforeMonth = intArrayOf(0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334)
    val leapDays = (year - 1) / 4 - (year - 1) / 100 + (year - 1) / 400
    val leapAdjustment = if (month > 2 && (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0))) 1 else 0
    return year * 365 + leapDays + daysBeforeMonth[month - 1] + leapAdjustment + day
}
private fun String.toEventDate(): EventDate? {
    val parts = trim().split(Regex("\\s+") )
    if (parts.size != 3) return null
    val month = mapOf("JAN" to 1, "FEB" to 2, "MAR" to 3, "APR" to 4, "MAY" to 5, "JUN" to 6, "JUL" to 7, "AUG" to 8, "SEP" to 9, "OCT" to 10, "NOV" to 11, "DEC" to 12)[parts[1].uppercase()] ?: return null
    return EventDate(parts[2].toIntOrNull() ?: return null, month, parts[0].toIntOrNull() ?: return null)
}

private data class EventAttachmentUi(val file: PlatformFile?, val name: String, val sizeLabel: String, val isVideo: Boolean, val bytes: ByteArray? = null, val previewUrl: String? = null, val fileId: String? = null)
private data class EventDocumentAttachmentUi(val file: PlatformFile?, val name: String, val type: String, val sizeLabel: String, val fileId: String? = null, val url: String = "")
private const val MaxEventAttachmentBytes = 10L * 1024L * 1024L

private fun EventResponse.toEventViewRow(fallback: EventRowUi?, attachments: List<EventAttachmentDetailUi> = emptyList()): EventRowUi = EventRowUi(
    id = eventId.orEmpty().ifBlank { id.orEmpty().ifBlank { fallback?.id ?: "—" } },
    backendId = id.orEmpty().ifBlank { fallback?.backendId ?: "" },
    title = title.orEmpty().ifBlank { fallback?.title ?: "Untitled event" },
    eventType = audience.orEmpty().ifBlank { fallback?.eventType ?: "Other" },
    publishedOn = createdAt.toEventDisplayDate(),
    expiryDate = eventDate.toEventDisplayDate(),
    status = when {
        !status.isNullOrBlank() -> status.toEventDisplayStatus()
        isActive == false -> "Draft"
        else -> "Published"
    },
    description = description.orEmpty(),
    audience = audience.orEmpty().ifBlank { fallback?.audience ?: "All Parents" },
    imageUrl = attachmentFileUrls.orEmpty().firstOrNull().orEmpty(),
    attachmentFileIds = attachmentFileIds.orEmpty(),
    attachmentFileUrls = attachmentFileUrls.orEmpty(),
    attachments = attachments
)

private fun String.toEventDisplayStatus(): String = when (trim().uppercase()) {
    "DRAFT" -> "Draft"
    "PUBLISHED" -> "Published"
    "EXPIRED" -> "Expired"
    else -> trim().replace('_', ' ').lowercase().replaceFirstChar { it.uppercase() }
}

@Composable private fun AddEventDialog(initial: EventRowUi? = null, audienceOptions: List<EventAudienceOption> = emptyList(), classTargetOptions: List<EventClassTargetOption> = emptyList(), isSaving: Boolean = false, isLoadingDetails: Boolean = false, errorMessage: String = "", onDismiss: () -> Unit, onSubmit: (EventDraft) -> Unit) {
    key(initial?.id ?: "new", initial?.attachments?.hashCode() ?: 0) {
    val minimumEventDate = currentAppDateLabel()
    var title by remember { mutableStateOf(initial?.title.orEmpty()) }
    var publishedOn by remember { mutableStateOf(initial?.publishedOn.orEmpty()) }
    var date by remember { mutableStateOf(initial?.expiryDate.orEmpty()) }
    var details by remember { mutableStateOf(initial?.description.orEmpty()) }
    var audience by remember { mutableStateOf(initial?.audience ?: "All") }
    var classTargetIds by remember(initial?.id) { mutableStateOf(emptyList<String>()) }
    LaunchedEffect(audienceOptions, initial?.audience) {
        val current = audience.trim()
        val resolved = audienceOptions.firstOrNull { option ->
            option.code.equals(current, ignoreCase = true) || option.label.equals(current, ignoreCase = true)
        } ?: audienceOptions.firstOrNull { initial == null && current.equals("All", ignoreCase = true) }
        resolved?.let { audience = it.label }
    }
    var audienceExpanded by remember { mutableStateOf(false) }
    var attachments by remember(initial?.id) { mutableStateOf(initial?.let(::editMediaForEvent).orEmpty()) }
    var documentAttachments by remember(initial?.id) { mutableStateOf(initial?.let(::editDocumentsForEvent).orEmpty()) }
    var previewVisible by remember { mutableStateOf(false) }
    var isUploadingFiles by remember { mutableStateOf(false) }
    var attachmentError by remember { mutableStateOf("") }
    var hasSubmitted by remember { mutableStateOf(false) }
    var uploadSession by remember {
        mutableStateOf(
            FileUploadRepository.newSession("EVENT").copy(
                recordId = initial?.backendId?.takeIf { it.isNotBlank() },
                uploadedFileIds = initial?.attachmentFileIds.orEmpty()
            )
        )
    }
    val scope = rememberCoroutineScope()
    val attachmentPicker = rememberFilePickerLauncher(type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png")), mode = PickerMode.Multiple(), title = "Select event attachments") { files ->
        if (files != null) scope.launch {
            isUploadingFiles = true
            attachmentError = ""
            for (file in files) {
                val existingNames = (attachments.map { it.name } + documentAttachments.map { it.name })
                if (existingNames.any { it.equals(file.name, ignoreCase = true) }) continue
                val bytes = runCatching { file.readBytes() }.getOrNull() ?: continue
                if (bytes.isEmpty()) {
                    attachmentError = "Unable to read ${file.name}."
                    continue
                }
                if (bytes.size.toLong() > MaxEventAttachmentBytes) {
                    attachmentError = "${file.name} must be 10 MB or smaller."
                    continue
                }
                val extension = file.name.substringAfterLast('.', "").lowercase()
                val isImage = extension in setOf("jpg", "jpeg", "png")
                val uploadBytes = if (isImage) resizeImage(bytes) else bytes
                val uploadFilename = if (isImage && uploadBytes !== bytes) "${file.name.substringBeforeLast('.', file.name)}.jpg" else file.name
                FileUploadRepository.upload(uploadSession, uploadFilename, eventContentType(uploadFilename), uploadBytes).fold(
                    onSuccess = { uploaded ->
                        uploadSession = uploaded.first
                        if (isImage) {
                            attachments = (attachments + EventAttachmentUi(file, file.name, formatEventAttachmentSize(bytes.size.toLong()), false, uploadBytes, fileId = uploaded.second.fileId)).distinctBy { it.name }
                        } else {
                            documentAttachments = (documentAttachments + EventDocumentAttachmentUi(file, file.name, extension.ifBlank { "FILE" }.uppercase(), formatEventAttachmentSize(bytes.size.toLong()), uploaded.second.fileId)).distinctBy { it.name }
                        }
                    },
                    onFailure = { attachmentError = it.message ?: "Unable to upload ${file.name}." }
                )
            }
            isUploadingFiles = false
        }
    }
    val titleError = if (hasSubmitted && title.isBlank()) "Event title is required." else ""
    val audienceError = if (hasSubmitted && audience.isBlank()) "Audience is required." else ""
    val dateError = if (hasSubmitted) eventDateValidationError(date, minimumEventDate) else ""
    val detailsError = if (hasSubmitted && details.isBlank()) "Event details are required." else ""
    val audienceCode = audienceOptions.firstOrNull { it.label.equals(audience, true) || it.code.equals(audience, true) }?.code.orEmpty()
    val classTargetError = if (hasSubmitted && audienceCode == "CLASS" && classTargetIds.isEmpty()) "Select at least one class." else ""
    val attachmentCount = attachments.size + documentAttachments.size
    val attachmentsError = if (hasSubmitted && attachmentCount == 0) "At least one attachment is required." else ""
    val canSave = listOf(titleError, audienceError, dateError, detailsError, classTargetError, attachmentsError).all { it.isBlank() } &&
        title.isNotBlank() && audience.isNotBlank() && details.isNotBlank() && attachmentCount > 0
    AppDialogScaffold(onDismiss = onDismiss, size = AppDialogSize.Wide, maxDialogHeight = 840.dp, isLoading = isUploadingFiles || isSaving || isLoadingDetails, loadingTitle = when { isUploadingFiles -> "Uploading attachments"; isLoadingDetails -> "Loading event details"; else -> "Saving event" }) {
        AppDialogHeader(title = if (initial == null) "Add Event & News" else "Edit Event & News  |  ${initial.id}", subtitle = if (initial == null) "Create and publish an event or share news with parents." else "Update event details and media.", onClose = onDismiss, icon = Res.drawable.calendar, iconContentDescription = "Event", colors = AppDialogDefaultColors)
        AppDialogValidationSummary(errors = listOf(titleError, audienceError, dateError, detailsError, classTargetError, attachmentsError), modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp))
        AppDialogErrorMessage(message = errorMessage, modifier = Modifier.padding(horizontal = 28.dp, vertical = 4.dp))
        Column(Modifier.fillMaxWidth().weight(1f).verticalScroll(rememberScrollState()).padding(horizontal = 28.dp, vertical = 16.dp), verticalArrangement = Arrangement.spacedBy(18.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(24.dp), modifier = Modifier.fillMaxWidth()) {
                AppDialogLabeledTextField("Event Title", title, { title = it }, "Enter event title", modifier = Modifier.weight(1.15f), required = true, error = titleError, colors = AppDialogDefaultColors, maxLength = 200, trailingIcon = { AppText("${title.length}/200", color = AppMuted, style = MaterialTheme.typography.labelSmall) })
                AppDialogFieldColumn("Audience", required = true, error = audienceError, modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) {
                    AppDialogSelectField(audience, "Select audience", audienceExpanded, audienceOptions.map { it.label }, { audienceExpanded = true }, { audienceExpanded = false }, { audience = it; audienceExpanded = false }, colors = AppDialogDefaultColors, error = audienceError)
                }
            }
            if (audienceCode == "CLASS") {
                var classTargetsExpanded by remember { mutableStateOf(false) }
                val selectedClassLabels = classTargetIds.mapNotNull { id -> classTargetOptions.firstOrNull { it.id == id }?.label }
                AppDialogFieldColumn("Classes", required = true, error = classTargetError, colors = AppDialogDefaultColors) {
                    AppDialogMultiSelectField(
                        selectedValues = selectedClassLabels,
                        placeholder = if (classTargetOptions.isEmpty()) "Loading classes…" else "Select classes",
                        options = classTargetOptions.map { it.label },
                        expanded = classTargetsExpanded,
                        onToggleExpanded = { classTargetsExpanded = !classTargetsExpanded },
                        onDismissExpanded = { classTargetsExpanded = false },
                        onSelectionChanged = { selected -> classTargetIds = selected.mapNotNull { label -> classTargetOptions.firstOrNull { it.label == label }?.id } },
                        error = classTargetError
                    )
                }
            }
            if (initial == null) {
                Row(horizontalArrangement = Arrangement.spacedBy(24.dp), modifier = Modifier.fillMaxWidth()) {
                    AppDialogFieldColumn("Expiry Date", required = true, error = dateError, modifier = Modifier.width(305.dp), colors = AppDialogDefaultColors) { AppDialogDateField(date, { date = it }, colors = AppDialogDefaultColors, error = dateError, minimumDate = minimumEventDate) }
                }
            } else {
                Row(horizontalArrangement = Arrangement.spacedBy(24.dp), modifier = Modifier.fillMaxWidth()) {
                    AppDialogFieldColumn("Published On", modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) {
                        AppDialogTextField(publishedOn, {}, "DD MMM YYYY", colors = AppDialogDefaultColors, readOnly = true, leadingIcon = { Icon(painterResource(Res.drawable.calendar), null, tint = AppMuted, modifier = Modifier.size(18.dp)) })
                    }
                    AppDialogFieldColumn("Expiry Date", required = true, error = dateError, modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) { AppDialogDateField(date, { date = it }, colors = AppDialogDefaultColors, error = dateError, minimumDate = minimumEventDate) }
                }
            }
            AppDialogFieldColumn("Event Details", required = true, error = detailsError, colors = AppDialogDefaultColors) {
                AppDialogTextField(details, { details = it }, "Enter event details here...", colors = AppDialogDefaultColors, error = detailsError, fieldHeight = 150.dp, singleLine = false, maxLength = 2000, trailingIcon = { AppText("${details.length}/2000", color = AppMuted, style = MaterialTheme.typography.labelSmall) })
            }
            AppDialogFieldColumn("Attachments", required = true, error = attachmentsError, colors = AppDialogDefaultColors) {
                Box(
                    Modifier
                        .fillMaxWidth()
                        .height(72.dp)
                        .border(1.dp, AppBorder, RoundedCornerShape(8.dp))
                        .background(AppPrimarySoft, RoundedCornerShape(8.dp))
                        .padding(horizontal = 18.dp),
                    contentAlignment = Alignment.CenterStart
                ) {
                    Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
                        Row(Modifier.weight(1f), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
                            Icon(painterResource(Res.drawable.document), null, tint = AppPrimary, modifier = Modifier.size(30.dp))
                            Column(Modifier.weight(1f)) {
                                Text(
                                    if (attachmentCount == 0) "No files selected" else "$attachmentCount file${if (attachmentCount == 1) "" else "s"} selected",
                                    color = AppNavy,
                                    style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                                Text(
                                    "Supported formats: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG · Maximum size: 10 MB per file",
                                    color = AppMuted,
                                    style = MaterialTheme.typography.bodySmall,
                                    maxLines = 2,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                        Text(
                            "Browse Files",
                            color = AppPrimary,
                            style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold),
                            maxLines = 1,
                            modifier = Modifier.widthIn(min = 92.dp).clickable { attachmentPicker.launch() }
                        )
                    }
                }
                val formAttachments = attachments.map { it.name to it.fileId } + documentAttachments.map { it.name to it.fileId }
                if (formAttachments.isNotEmpty()) {
                    Column(verticalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.padding(top = 10.dp)) {
                        formAttachments.chunked(2).forEach { row ->
                            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                                row.forEach { (name, fileId) ->
                                    val media = attachments.firstOrNull { it.name == name }
                                    val document = documentAttachments.firstOrNull { it.name == name }
                                    EventAttachmentChip(name, media?.let { if (it.isVideo) "MP4" else name.substringAfterLast('.', "FILE").uppercase() } ?: document?.type.orEmpty(), media?.sizeLabel ?: document?.sizeLabel.orEmpty(), media?.bytes, Modifier.weight(1f)) {
                                        if (media != null) attachments = attachments - media else if (document != null) documentAttachments = documentAttachments - document
                                        fileId?.takeIf { it !in initial?.attachmentFileIds.orEmpty() }?.let { id -> scope.launch { FileUploadRepository.delete(id) } }
                                    }
                                }
                                if (row.size == 1) Spacer(Modifier.weight(1f))
                            }
                        }
                    }
                }
            }
            if (attachmentError.isNotBlank()) AppText(attachmentError, color = AppDanger, style = MaterialTheme.typography.labelSmall)
        }
    AppDialogFooter(
                    actions = listOf(AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 140.dp)) +
                (if (initial == null) listOf(AppDialogFooterAction("Save as Draft", { hasSubmitted = true; if (canSave && !isUploadingFiles && !isSaving) onSubmit(EventDraft(title.trim(), date, details.trim(), audience.trim(), false, attachments.mapNotNull { it.fileId } + documentAttachments.mapNotNull { it.fileId })) }, AppDialogActionStyle.Secondary, width = 170.dp)) else emptyList()) +
                listOf(AppDialogFooterAction(if (initial == null) "Save & Publish" else "Save", {
                    hasSubmitted = true
                    if (canSave && !isUploadingFiles && !isSaving) {
                        val selectedFileIds = attachments.mapNotNull { it.fileId } + documentAttachments.mapNotNull { it.fileId }
                        onSubmit(EventDraft(
                            title = title.trim(),
                            date = date,
                            description = details.trim(),
                            audience = audience.trim(),
                            isActive = true,
                            attachmentFileIds = selectedFileIds,
                            eventId = initial?.backendId,
                            removedAttachmentFileIds = initial?.attachmentFileIds.orEmpty().filterNot { it in selectedFileIds },
                            classTargetIds = classTargetIds,
                            existingStatus = initial?.status
                        ))
                    }
                }, AppDialogActionStyle.Primary, width = 180.dp)),
            colors = AppDialogDefaultColors,
            equalWeightButtons = false,
            leadingContent = {
                AppDialogFooterButton(
                    action = AppDialogFooterAction("Preview", { previewVisible = true }, AppDialogActionStyle.Secondary, width = 140.dp),
                    colors = AppDialogDefaultColors,
                    modifier = Modifier.width(140.dp)
                )
            }
        )
    }
    if (previewVisible) {
        EventPreviewDialog(
            event = EventRowUi(
                id = "PREVIEW",
                title = title.ifBlank { "Untitled Event" },
                imageUrl = "https://placehold.co/96x64/png?text=Event",
                eventType = "Other",
                publishedOn = date.ifBlank { "—" },
                expiryDate = date.ifBlank { "—" },
                status = "Draft"
            ),
            audience = audience,
            details = details,
            media = attachments,
            documents = documentAttachments,
            onDismiss = { previewVisible = false }
        )
    }
    }
}

private fun editMediaForEvent(event: EventRowUi): List<EventAttachmentUi> {
    val fromDetail = event.attachments.filter { it.mimeType.startsWith("image/", true) || it.mimeType.startsWith("video/", true) }
        .map { EventAttachmentUi(null, it.name, it.sizeLabel, it.mimeType.startsWith("video/", true), it.previewBytes, it.url, it.fileId) }
    if (fromDetail.isNotEmpty()) return fromDetail
    if (event.attachmentFileIds.isNotEmpty() || event.attachmentFileUrls.isNotEmpty()) {
        return (0 until maxOf(event.attachmentFileIds.size, event.attachmentFileUrls.size)).map { index ->
            EventAttachmentUi(null, "Attachment ${index + 1}", "Existing attachment", false, previewUrl = event.attachmentFileUrls.getOrNull(index).orEmpty(), fileId = event.attachmentFileIds.getOrNull(index))
        }
    }
    // Do not fabricate attachment cards when the API returns no media.
    return emptyList()
}

private fun editDocumentsForEvent(event: EventRowUi): List<EventDocumentAttachmentUi> = event.attachments
    .filterNot { it.mimeType.startsWith("image/", true) || it.mimeType.startsWith("video/", true) }
    .map { EventDocumentAttachmentUi(null, it.name, it.mimeType.substringAfterLast('/', "FILE").uppercase(), it.sizeLabel, it.fileId, it.url) }

@Composable
private fun EventPreviewDialog(
    event: EventRowUi?,
    audience: String? = null,
    details: String? = null,
    media: List<EventAttachmentUi>? = null,
    documents: List<EventDocumentAttachmentUi>? = null,
    isLoading: Boolean = false,
    errorMessage: String = "",
    onDismiss: () -> Unit
) {
    if (event == null) return
    val displayAudience = audience?.ifBlank { null } ?: event.audience
    val displayDetails = details?.ifBlank { null } ?: event.description
    val displayMedia = media ?: listOf(
        EventAttachmentUi(null, "${event.eventType} Highlights.jpg", "2.4 MB", isVideo = false, previewUrl = event.imageUrl),
        EventAttachmentUi(null, "${event.eventType} Moments.jpg", "3.1 MB", isVideo = false, previewUrl = event.imageUrl),
        EventAttachmentUi(null, "${event.eventType} Gallery.jpg", "2.8 MB", isVideo = false, previewUrl = event.imageUrl)
    )
    val displayDocuments = documents ?: listOf(EventDocumentAttachmentUi(null, "${event.eventType}_Guidelines.pdf", "PDF", "245 KB"))
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        maxDialogHeight = 820.dp,
        isLoading = isLoading,
        loadingTitle = "Loading event details"
    ) {
        AppDialogHeader(title = "Preview Event & News", subtitle = "This is how the event/news will appear to recipients.", onClose = onDismiss, icon = Res.drawable.eye, iconContentDescription = "Preview", colors = AppDialogDefaultColors)
        Column(Modifier.fillMaxWidth().weight(1f).verticalScroll(rememberScrollState()).padding(horizontal = 24.dp, vertical = 16.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
            if (isLoading) {
                AppText("Loading event details…", color = AppMuted)
            } else if (errorMessage.isNotBlank()) {
                AppDialogErrorMessage(errorMessage)
            } else AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = AppSurface) {
                Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                        Box(Modifier.size(56.dp).background(AppPrimary, RoundedCornerShape(50)), contentAlignment = Alignment.Center) { Icon(painterResource(Res.drawable.calendar), null, tint = Color.White, modifier = Modifier.size(28.dp)) }
                        Column(Modifier.weight(1f)) {
                            AppText(event.title, color = AppNavy, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold)
                            AppText("Greenfield High School   •   Published On: ${event.publishedOn}   •   $displayAudience", color = AppMuted, style = MaterialTheme.typography.bodyMedium)
                        }
                    }
                    HorizontalDivider(color = AppBorder)
                    AppText("Audience", color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    Surface(color = AppPrimarySoft, shape = RoundedCornerShape(8.dp)) { Row(Modifier.padding(horizontal = 12.dp, vertical = 8.dp), verticalAlignment = Alignment.CenterVertically) { Icon(painterResource(Res.drawable.users), null, tint = AppPrimary, modifier = Modifier.size(18.dp)); Spacer(Modifier.width(8.dp)); AppText(displayAudience, color = AppPrimary, fontWeight = FontWeight.Bold) } }
                    AppText("This event will be visible to ${displayAudience.lowercase()} and staff.", color = AppNavy, style = MaterialTheme.typography.bodyMedium)
                    AppText("Event Details", color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    Surface(Modifier.fillMaxWidth(), color = AppSecondaryBackground, shape = RoundedCornerShape(8.dp), border = BorderStroke(1.dp, AppBorder)) { AppText(displayDetails.ifBlank { "No event details entered yet." }, Modifier.padding(16.dp), color = AppNavy, style = MaterialTheme.typography.bodyMedium) }
                    AppText("Photos & Videos (${displayMedia.size})", color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    if (displayMedia.isNotEmpty()) {
                        Column(verticalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                            displayMedia.chunked(4).forEach { mediaRow ->
                                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.Top) {
                                    mediaRow.forEach { item -> EventPreviewMediaCard(item.previewUrl ?: event.imageUrl, item.name, item.bytes, Modifier.weight(1f)) }
                                    repeat(4 - mediaRow.size) { Spacer(Modifier.weight(1f)) }
                                }
                            }
                        }
                    }
                    AppText("Attachments (${displayDocuments.size})", color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    if (displayDocuments.isNotEmpty()) {
                        Column(verticalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                            displayDocuments.chunked(2).forEach { attachmentRow ->
                                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.Top) {
                                    attachmentRow.forEach { attachment -> EventPreviewAttachmentRow(attachment, Modifier.weight(1f)) }
                                    if (attachmentRow.size == 1) Spacer(Modifier.weight(1f))
                                }
                            }
                        }
                    }
                    HorizontalDivider(color = AppBorder)
                    AppText("Expiry Date\n${event.expiryDate}", color = AppNavy, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Medium)
                }
            }
        }
        AppDialogFooter(actions = listOf(AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Secondary, width = 120.dp)), colors = AppDialogDefaultColors)
    }
}

@Composable
private fun EventPreviewMediaCard(url: String, name: String, bytes: ByteArray? = null, modifier: Modifier) {
    Surface(modifier, shape = RoundedCornerShape(8.dp), color = AppSurface, border = BorderStroke(1.dp, AppBorder)) {
        Column {
            if (bytes != null) {
                var image by remember(name) { mutableStateOf<ImageBitmap?>(null) }
                LaunchedEffect(name) { image = decodeImageBitmap(bytes) }
                if (image != null) Image(image!!, contentDescription = "Event media", modifier = Modifier.fillMaxWidth().height(86.dp), contentScale = ContentScale.Crop)
                else RemoteEventImage(url, Modifier.fillMaxWidth().height(86.dp))
            } else RemoteEventImage(url, Modifier.fillMaxWidth().height(86.dp))
            Column(Modifier.padding(8.dp)) { Text(name, color = AppNavy, style = MaterialTheme.typography.labelSmall, maxLines = 1, overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis); AppText("2.4 MB", color = AppMuted, style = MaterialTheme.typography.labelSmall) }
        }
    }
}

@Composable
private fun RemoteEventImage(url: String, modifier: Modifier = Modifier) {
    var image by remember(url) { mutableStateOf<ImageBitmap?>(null) }
    LaunchedEffect(url) { FileUploadRepository.downloadBytes(url).onSuccess { bytes -> image = decodeImageBitmap(bytes) } }
    if (image != null) Image(image!!, contentDescription = "Event media", modifier = modifier, contentScale = ContentScale.Crop)
    else Box(modifier.background(AppPrimarySoft), contentAlignment = Alignment.Center) { Icon(painterResource(Res.drawable.calendar), null, tint = AppPrimary, modifier = Modifier.size(24.dp)) }
}

@Composable
private fun EventPreviewAttachmentRow(attachment: EventDocumentAttachmentUi, modifier: Modifier = Modifier) {
    val uriHandler = androidx.compose.ui.platform.LocalUriHandler.current
    Row(modifier.fillMaxWidth().height(58.dp).border(1.dp, AppBorder, RoundedCornerShape(8.dp)).padding(horizontal = 10.dp), verticalAlignment = Alignment.CenterVertically) {
        Box(Modifier.size(30.dp).background(AppDangerSoft, RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) { Icon(painterResource(Res.drawable.document), null, tint = AppDanger, modifier = Modifier.size(18.dp)) }
        Spacer(Modifier.width(8.dp)); Column(Modifier.weight(1f)) { AppText(attachment.name, color = AppNavy, style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.Bold); AppText("${attachment.type}  •  ${attachment.sizeLabel}", color = AppMuted, style = MaterialTheme.typography.labelSmall) }
        Icon(painterResource(Res.drawable.download), "Download attachment", tint = if (attachment.url.isBlank()) AppMuted else AppPrimary, modifier = Modifier.size(20.dp).then(if (attachment.url.isBlank()) Modifier else Modifier.clickable { uriHandler.openUri(attachment.url) }))
    }
}

@Composable
private fun EventAttachmentChip(
    name: String,
    type: String,
    sizeLabel: String,
    previewBytes: ByteArray?,
    modifier: Modifier,
    onRemove: () -> Unit
) {
    Row(
        modifier = modifier.height(72.dp).border(1.dp, AppBorder, RoundedCornerShape(8.dp)).padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        val preview = previewBytes?.let(::decodeImageBitmap)
        if (preview != null) {
            Image(bitmap = preview, contentDescription = name, modifier = Modifier.size(52.dp), contentScale = ContentScale.Fit)
        } else {
            Box(Modifier.size(36.dp).background(AppPrimarySoft, RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.document), null, tint = AppPrimary, modifier = Modifier.size(19.dp))
            }
        }
        Spacer(Modifier.width(8.dp))
        Column(Modifier.weight(1f)) {
            Text(name, color = AppNavy, fontSize = 12.sp, maxLines = 1, overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis)
            Text("$type  •  $sizeLabel", color = AppMuted, fontSize = 11.sp)
        }
        Icon(painterResource(Res.drawable.close_x), "Remove $name", tint = AppNavy, modifier = Modifier.size(18.dp).clickable(onClick = onRemove))
    }
}

private fun formatEventAttachmentSize(bytes: Long): String = when { bytes < 1024L -> "$bytes B"; bytes < 1024L * 1024L -> "${bytes / 1024} KB"; else -> "${bytes / (1024L * 1024L)} MB" }

private fun eventDateValidationError(value: String, minimumDate: String): String = when {
    value.isBlank() -> "Event date is required."
    normalizeAppDateInput(value) == null -> "Enter a valid date in DD MMM YYYY format."
    appDateInputComparable(value)?.let { entered -> appDateInputComparable(minimumDate)?.let { minimum -> entered < minimum } } == true -> "Event date cannot be earlier than today."
    else -> ""
}

private fun String?.toEventDisplayDate(): String {
    val parts = this.orEmpty().substringBefore('T').split('-')
    if (parts.size != 3) return this.orEmpty().ifBlank { "—" }
    val month = parts[1].toIntOrNull() ?: return this.orEmpty()
    val label = listOf("JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC").getOrNull(month - 1) ?: return this.orEmpty()
    return "${parts[2].padStart(2, '0')} $label ${parts[0]}"
}

private fun eventContentType(filename: String): String = when (filename.substringAfterLast('.', "").lowercase()) {
    "pdf" -> "application/pdf"
    "doc" -> "application/msword"
    "docx" -> "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    "xls" -> "application/vnd.ms-excel"
    "xlsx" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    "jpg", "jpeg" -> "image/jpeg"
    "png" -> "image/png"
    else -> "application/octet-stream"
}

@Composable private fun RowScope.EventMetric(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, bg: Color) = AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, bg, AppMuted, modifier = Modifier.weight(1f))

@Composable private fun EventsFilterPanel(state: EventsNewsUiState, onEvent: (EventsNewsUiEvent) -> Unit, onCustomRange: () -> Unit) {
    AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Row(Modifier.fillMaxWidth().padding(16.dp), horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.Bottom) {
            Column(Modifier.weight(1.45f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
                AppText("Search by Event ID / Title", color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelLarge)
                BoxWithConstraints(Modifier.fillMaxWidth()) {
                    AdminListSearchField(
                        value = state.searchQuery,
                        onValueChange = { onEvent(EventsNewsUiEvent.SearchChanged(it)) },
                        placeholder = "Search by Event ID or Title",
                        width = maxWidth,
                        height = 44.dp,
                        surfaceColor = AppSurface,
                        borderColor = AppBorder,
                        iconTint = AppMuted,
                        textColor = AppNavy,
                        cursorColor = AppPrimary
                    )
                }
            }
            val audienceLabel = state.audienceOptions.firstOrNull { it.code.equals(state.filters.eventType, ignoreCase = true) }?.label
                ?: state.filters.eventType.ifBlank { "All" }
            EventDropdown("Audience", audienceLabel, state.audienceOptions.map { it.label }, Modifier.weight(1f)) { selected ->
                val code = state.audienceOptions.firstOrNull { it.label.equals(selected, ignoreCase = true) }?.code.orEmpty()
                onEvent(EventsNewsUiEvent.FiltersChanged(state.filters.copy(eventType = code)))
            }
            val statusLabel = state.filters.status.takeIf { it.isNotBlank() }?.let {
                com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.label("EVENT_STATUS", it)
            } ?: "All"
            EventDropdown("Status", statusLabel, com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.labels("EVENT_STATUS"), Modifier.weight(.9f)) { selected ->
                val code = com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.code("EVENT_STATUS", selected)
                onEvent(EventsNewsUiEvent.FiltersChanged(state.filters.copy(status = code)))
            }
            EventDropdown("Published Date", state.filters.publishedDate, listOf("Today", "Last 7 Days", "This Month", "Custom Range"), Modifier.weight(1f)) {
                if (it.equals("Custom Range", ignoreCase = true)) onCustomRange()
                else onEvent(EventsNewsUiEvent.FiltersChanged(state.filters.copy(publishedDate = it, publishedDateFrom = "", publishedDateTo = "")))
            }
            AdminListToolbarButton(label = "Clear", icon = painterResource(Res.drawable.refresh_cw), onClick = { onEvent(EventsNewsUiEvent.FiltersReset) }, width = 116.dp, height = 44.dp, surfaceColor = AppSurface, borderColor = AppInputBorder, contentColor = AppPrimary)
        }
    }
}

@Composable
private fun CustomEventDateRangeDialog(
    visible: Boolean,
    initialFrom: String,
    initialTo: String,
    onDismiss: () -> Unit,
    onApply: (String, String) -> Unit
) {
    if (!visible) return
    AppDialogDatePickerDialog(
        value = initialFrom,
        onDismiss = onDismiss,
        onDateSelected = {},
        colors = AppDialogDefaultColors,
        dateRangeSelection = true,
        dateRangeStartValue = initialFrom,
        dateRangeEndValue = initialTo,
        onDateRangeSelected = onApply
    )
}

@Composable private fun EventDropdown(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) =
    AppLabeledDropdownField(
        label = label,
        value = value.ifBlank { "All" },
        options = options,
        onSelected = onSelected,
        modifier = modifier,
        allOptionLabel = "All"
    )

@Composable private fun EventHeader(state: EventsNewsUiState, onEvent: (EventsNewsUiEvent) -> Unit) = AdminListSortHeaderRow(listOf(
    AdminListSortColumn("Event ID", .9f, state.sortField == EventsSortField.ID, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.ID)) },
    AdminListSortColumn("Title", 1.6f, state.sortField == EventsSortField.TITLE, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.TITLE)) },
    AdminListSortColumn("Audience", 1.1f, state.sortField == EventsSortField.AUDIENCE, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.AUDIENCE)) },
    AdminListSortColumn("Published On", 1f, state.sortField == EventsSortField.PUBLISHED_DATE, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.PUBLISHED_DATE)) },
    AdminListSortColumn("Expiry Date", 1f, state.sortField == EventsSortField.EXPIRY_DATE, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.EXPIRY_DATE)) },
    AdminListSortColumn("Status", .8f, state.sortField == EventsSortField.STATUS, state.sortAscending) { onEvent(EventsNewsUiEvent.SortChanged(EventsSortField.STATUS)) }
), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center)

@Composable
private fun EventRow(row: EventRowUi, onView: () -> Unit, onEdit: () -> Unit, onDelete: () -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    Row(Modifier.fillMaxWidth().onViewDoubleClick(onView).heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        AppText(row.id, Modifier.weight(.9f), color = AppNavy, fontWeight = FontWeight.Normal)
        Row(Modifier.weight(1.6f), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            AppText(row.title, Modifier.weight(1f), color = AppNavy, fontWeight = FontWeight.Normal)
        }
        listOf(row.eventType to 1.1f, row.publishedOn to 1f, row.expiryDate to 1f).forEach { (value, weight) -> AppText(value, Modifier.weight(weight), color = AppNavy, fontWeight = FontWeight.Normal) }
        Box(Modifier.weight(.8f)) { AppText(row.status, color = if (row.status == "Expired") AppDanger else AppSuccess, fontWeight = FontWeight.Normal) }
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            AdminListActionIcons(onView = { expanded = false; onView() }, onEdit = { expanded = false; onEdit() }) {
                IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                AdminRowActionMenu(
                    sections = listOf(listOf(AdminRowActionItem("Delete", { expanded = false; onDelete() }, painterResource(Res.drawable.trash), labelColor = AppDanger, iconTint = AppDanger))),
                    onDismissRequest = { expanded = false }, expanded = expanded
                )
            }
        }
    }
}

@Composable
private fun RowScope.EventSummaryCardsShimmer() = AdminListSummaryCardsShimmer(
    cardCount = 4,
    cardHeight = 128.dp,
    cardShape = RoundedCornerShape(12.dp),
    contentPadding = PaddingValues(22.dp),
    iconSize = 70.dp,
    horizontalSpacing = 20.dp,
    titleWidth = 118.dp,
    titleHeight = 15.dp,
    valueWidth = 72.dp,
    valueHeight = 31.dp,
    subtitleWidth = 132.dp,
    subtitleHeight = 12.dp
)
